import { Component, OnInit } from '@angular/core';
import { Clasificacion } from '../../domain/clasificacion';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClasificacionService } from '../../service/clasificacion.service';
import { GenericResponse } from '../../domain/genericResponse';
import { GLOBAL } from '../../global';
import { ParteService } from '../../service/parte.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  public categorias: Array<Clasificacion> = new Array<Clasificacion>();
  public form: FormGroup;
  private categoriaDefecto : Clasificacion;
  public categoria : Clasificacion;

  constructor(private activatedRoute: ActivatedRoute, 
    private formBuilder:FormBuilder,
    private clasificacionService: ClasificacionService,
    private parteService: ParteService,
    private router: Router) { }

  ngOnInit() {
    this.categoriaDefecto = new Clasificacion(-1, "-1", "Todas las Categorias", null);
    this.getCategorias();

    var keyWords = '';
    this.categoria = this.categoriaDefecto;

    this.activatedRoute.params.subscribe(params => {
      //keyWords = params['keywords'];
      //this.categoria = params['category'];
    });

    this.form = this.formBuilder.group({
      'keyWords' : keyWords,
    });
  }

  getCategorias(){
    //Obtengo la lista de clasificaciones y le agrego una por defecto
    this.clasificacionService.getDataClasificacion().subscribe(data=>{
      let respuestaGenerica:GenericResponse = data;
      if(respuestaGenerica.codigo===GLOBAL.HTTP_OK){
        this.categorias=respuestaGenerica.lista;
      }
      this.categorias.unshift(this.categoriaDefecto);
    },error=>{
    });
  }

  onSearch(){
    this.parteService.paginaCargada = false;
    this.router.navigate(['/products/search/', this.categoria.codigo, this.form.controls.keyWords.value]);
  }

  public changeCategory(event) {
    if (event.target) {
      this.categoria = this.categorias.filter(categoria => categoria.descripcion == event.target.innerText)[0];
    }
  }

  public stopClickPropagate(event: any) {
    if(window.innerWidth < 960){
      event.preventDefault();
      event.stopPropagation();
    }
  }

}
